module.exports = __webpack_public_path__ + "static/Wantsome-elk-for-beginners.7fe70526.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/community-events/Wantsome-elk-for-beginners.png
// module id = 559
// module chunks = 85204117838356